import React from 'react'
import SubscriptionGate from './SubscriptionGate'

// The Critical Care suite — the Critical Care ePCR record type and live
// consoles, DOPS assessments, procedure logbooks and drawn-up medicines — is
// an Enterprise feature. One shared gate so the copy stays consistent across
// the suite's routes and the settings card (pass inline for the card form).
// The server enforces the same rule (helpers/epcr/criticalCareAccess.js).
export const CRITICAL_CARE_TIER = 3

const CRITICAL_CARE_BENEFITS = [
  'Run Critical Care ePCRs with tap-first live consoles for pre-hospital emergency anaesthesia, cardiac arrest and blood products',
  'Capture DOPS assessments against real recorded procedures, with structured assessor feedback and trainee reflections',
  'Track every clinician’s procedure logbook and skill currency automatically from their patient records',
  'Manage drawn-up medicines with full traceability from draw-up to administration, handover or discard',
]

const CriticalCareGate = ({ children, inline, onGoBack }) => (
  <SubscriptionGate
    requiredTier={CRITICAL_CARE_TIER}
    featureName="Critical Care"
    caption="Critical Care ePCRs, DOPS, logbooks and drawn-up medicines are part of the Enterprise plan."
    benefits={CRITICAL_CARE_BENEFITS}
    areNotIs
    inline={inline}
    onGoBack={onGoBack}
  >
    {children}
  </SubscriptionGate>
)

export default CriticalCareGate
